/***********************************************************************************
 * Spinner Component
 * A vue component to display Zip Spinner
 *
 * @author Zip Co - Plugin Team
 *
 ***********************************************************************************/

import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
class Spinner extends Vue {
    @Prop()
    public message!: string;

    @Prop()
    public error!: boolean;

    /**
     * get style for message
     */
    private get style(): string {
        return `${this.error ? 'red--text text--darken-2 ' : ''}headline`;
    }
}

export default Spinner;
